<template>
  <div :class="classnames">
    <h5 :class="`${ns}__title`">Share.</h5>

    <div :class="`${ns}__body`">
      <div :class="`${ns}__page-teaser`">
        <template v-if="thumbnailUrl">
          <div :class="`${ns}__page-image`">
            <img :class="`${ns}__page-thumbnail`" :src="thumbnailUrl" />
          </div>
        </template>

        <div :class="`${ns}__page-text`">
          <template v-if="pageSubline">
            <div :class="`${ns}__page-subline`">{{ pageSubline }}</div>
          </template>

          <template v-if="pageHeadline">
            <div :class="`${ns}__page-headline`">{{ pageHeadline }}</div>
          </template>
        </div>
      </div>

      <template v-if="shareLinkUrl">
        <copy-text :text="shareLinkUrl" />
      </template>

      <!--
      <tabs>
        <tabs-nav>
          <tabs-nav-item>
            <template slot="icon">
              <svg-icon-link />
            </template>
            <template slot="label">Link</template>
          </tabs-nav-item>

          <tabs-nav-item>
            <template slot="icon">
              <svg-icon-mail />
            </template>
            <template slot="label">Email</template>
          </tabs-nav-item>

          <tabs-nav-item>
            <template slot="icon">
              <svg-icon-slack />
            </template>
            <template slot="label">Slack</template>
          </tabs-nav-item>
        </tabs-nav>

        <tabs-content>
          <tabs-content-item>
            <div :class="`${ns}__page-teaser`">
              <template v-if="thumbnailUrl">
                <div :class="`${ns}__page-image`">
                  <img :class="`${ns}__page-thumbnail`" :src="thumbnailUrl" />
                </div>
              </template>

              <div :class="`${ns}__page-text`">
                <template v-if="pageSubline">
                  <div :class="`${ns}__page-subline`">{{ pageSubline }}</div>
                </template>

                <template v-if="pageHeadline">
                  <div :class="`${ns}__page-headline`">{{ pageHeadline }}</div>
                </template>
              </div>
            </div>

            <template v-if="shareLinkUrl">
              <copy-text buttonLabel="Copy Link" :text="shareLinkUrl" />
            </template>
          </tabs-content-item>

          <tabs-content-item>
            <div>Email</div>
          </tabs-content-item>

          <tabs-content-item>
            <div>Slack</div>
          </tabs-content-item>
        </tabs-content>
      </tabs>
      -->
    </div>

    <p :class="`${ns}__footer`">Product information is subject to change. Link will expire in 72 hrs.</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import CopyText from '@/components/CopyText'
  import {
    Tabs,
    TabsContent,
    TabsContentItem,
    TabsNav,
    TabsNavItem
  } from '@/components/Tabs'

  import SvgIconLink from '@/svgs/SvgIconLink'
  import SvgIconMail from '@/svgs/SvgIconMail'
  import SvgIconSlack from '@/svgs/SvgIconSlack'

  import { createShareLink, getShareLinkUrl } from '@/utils/share.js'
  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-view-share'

  export default {
    name: 'ModalViewShare',
    components: {
      'copy-text': CopyText,
      'svg-icon-link': SvgIconLink,
      'svg-icon-mail': SvgIconMail,
      'svg-icon-slack': SvgIconSlack,
      'tabs': Tabs,
      'tabs-content': TabsContent,
      'tabs-content-item': TabsContentItem,
      'tabs-nav': TabsNav,
      'tabs-nav-item': TabsNavItem
    },
    mixins: [ bem ],
    props: {
      pageHeadline: {
        type: String
      },
      pageSubline: {
        type: String
      },
      productId: [ Number, String ],
      linkUrl: {
        type: String
      },
      thumbnailUrl: {
        type: String
      }
    },
    data: function () {
      return {
        shareLinkUrl: ' '
      }
    },
    computed: {
      ...mapState(
        'ui',
        [
          'filterDateRange',
          'filtersActiveProductDetailPage',
          'filtersActiveProductsPage',
          'selectedDateRange'
        ]
      )
    },
    created: function () {
      this.setNamespace(namespace)
    },
    mounted: function () {
      this.setShareLink()
    },
    methods: {
      setShareLink: function () {
        const {
          filterDateRange,
          filtersActiveProductDetailPage,
          filtersActiveProductsPage,
          selectedDateRange
        } = this

        // set the filters
        const data = {
          filterDateRange,
          filtersActiveProductDetailPage,
          filtersActiveProductsPage,
          selectedDateRange
        }

        // console.log('data from modal view share')
        // console.dir(data)

        createShareLink((id) => {
          const shareLinkUrl = getShareLinkUrl(id, this.productId)
          this.setState('shareLinkUrl', shareLinkUrl)
        }, data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalViewShare.vue